var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartLine({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.91667 16.667H17.0833C17.5436 16.667 17.9167 17.0401 17.9167 17.5003C17.9167 17.9606 17.5436 18.3337 17.0833 18.3337H2.08333C1.6231 18.3337 1.25 17.9606 1.25 17.5003V2.50033C1.25 2.04009 1.6231 1.66699 2.08333 1.66699C2.54357 1.66699 2.91667 2.04009 2.91667 2.50033V16.667ZM7.08333 12.0837C7.08333 12.774 6.52369 13.3337 5.83333 13.3337C5.14298 13.3337 4.58333 12.774 4.58333 12.0837C4.58333 11.3933 5.14298 10.8337 5.83333 10.8337L8.33333 8.33366C8.33333 7.6433 8.89298 7.08366 9.58333 7.08366C10.2737 7.08366 10.8333 7.6433 10.8333 8.33366L12.275 9.80033H12.4083L15.4167 6.79199C15.4126 6.75042 15.4126 6.70856 15.4167 6.66699C15.4167 5.97664 15.9763 5.41699 16.6667 5.41699C17.357 5.41699 17.9167 5.97664 17.9167 6.66699C17.9167 7.35735 17.357 7.91699 16.6667 7.91699L13.6333 10.9753V11.042C13.6333 11.7323 13.0737 12.292 12.3833 12.292C11.693 12.292 11.1333 11.7323 11.1333 11.042V10.9753L9.79167 9.63366H9.6H9.40833L7.08333 11.9587C7.0874 12.0002 7.0874 12.0421 7.08333 12.0837Z",
    fill: "#0024A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartLine);
export default __webpack_public_path__ + "static/media/chart-line.d95795192f2319ae2a10c3cfabeb5b5e.svg";
export { ForwardRef as ReactComponent };